import { Typography, Tag } from 'antd';

const { Title } = Typography;

export const RadDevicesPanel = ({ radDevices }) => {
    return (
        <div>
            <Title level={4}>ROADZ Armor Devices</Title>
            <div className="list">
                {radDevices?.length ? (
                    <ul className="listConfig">
                        {radDevices.map((rad, i) => (
                            <li className="configItem" key={i}>
                                <span style={{ fontWeight: 'bold' }}>{rad.serial_number}</span>
                                {rad.vehicle_name ? (
                                    <Tag color="green" style={{ marginLeft: '10px' }}>
                                        {rad.vehicle_name}
                                    </Tag>
                                ) : (
                                    <Tag color="default" style={{ marginLeft: '10px' }}>
                                        Unassigned
                                    </Tag>
                                )}
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="subgroupText">No ROADZ Armor devices in this group.</p>
                )}
            </div>
        </div>
    );
};
